



















































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Copy from "@/components/copy.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
// import LeftNav from "../../components/left-nav.vue";
import LeftNav from "../../../sjzx/modules/zbsjk/components/nav-left.vue";
import {
  GetHospitals,
  PostDataExport,
  GetDataExportTemplates,
} from "@/request/cdr";
import { GetTemplatesOfGroup, GetTopicsOfTemplate } from "@/request/projects";
import SelectMultiSearch from "./select-multi-search.vue";
@Component({
  components: {
    Copy,
    MainHeader,
    LeftNav,
    SelectMultiSearch,
  },
})
export default class CdrDataExport extends Vue {
  private project: any = {};
  private group: any = {};
  private hospitals: any[] = [];
  private filters: any = {
    表格名称: "",
    hospital_ids: [],
    开始时间: "",
    结束时间: "",
    时间段: "",
    条件: "全部条件",
    行研究指标: [],
    列研究指标: [],
    timeWay: "所有时间",
    time: [],
  };
  private ifAllHospital: any = false;
  private searchedTemplates: any[] = [];
  private rightTemplatesGroup: any[] = [];
  /**
   * @description 获得可选医院列表
   */
  private fetchHospitals() {
    const params: any = {
      params: {
        project_id: this.$route.query.project_id,
      },
    };
    GetHospitals(this, params).then((data: any) => {
      this.hospitals = data;
    });
  }
  /**
   * @description 点选全部医院时
   */
  private allHospitalChange(value) {
    if (value) {
      this.filters.hospital_ids = [""];
    } else {
      this.filters.hospital_ids = [];
    }
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["行研究指标"].push({ result: {}, selected: {} });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    GetTemplatesOfGroup(
      this,
      this.project.project_id,
      this.group.group_id
    ).then((data: any) => {
      this.searchedTemplates = data;
    });
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    GetTopicsOfTemplate(this, l.template_id).then((data: any) => {
      l.items = data;
      this.$forceUpdate();
    });
  }
  /**
   * @description 获得右侧可选的模板列表
   */
  private fetchRightTemplates() {
    const params: any = {
      params: {
        group_id: this.group.group_id,
      },
    };
    GetDataExportTemplates(this, params).then((data: any) => {
      data.map((item: any) => {
        item.opened = false;
      });
      if (data.length > 0) {
        data[0].opened = true;
      }
      this.rightTemplatesGroup = data;
    });
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["行研究指标"].splice(index, 1);
  }

  /**
   * @description 导出
   */
  private startExport() {
    if (!this.filters["表格名称"]) {
      this.$message.warning("表格名称不能为空");
      return;
    }
    if (this.filters.hospital_ids.length === 0) {
      this.$message.warning("请选择要导出的所属机构");
      return;
    }
    let hospitalIds: any[] = this.filters["hospital_ids"];
    if (this.filters["hospital_ids"][0] === "") {
      hospitalIds = [];
    }
    this.filters["列研究指标"] = this.rightTemplatesGroup;
    const params: any = {
      表格名称: this.filters["表格名称"],
      project_id: this.project.project_id,
      hospital_ids: hospitalIds,
      时间段: this.filters["timeWay"],
      条件: this.filters["条件"],
      列研究指标: this.filters["列研究指标"],
    };
    // 时间段
    if (this.filters.timeWay === "自定义") {
      params["开始时间"] = this.filters.time[0];
      params["结束时间"] = this.filters.time[1];
    }
    if (this.filters["行研究指标"].length > 0) {
      const arr: any[] = [];
      this.filters["行研究指标"].map((item: any) => {
        const i = JSON.parse(JSON.stringify(item.selected));
        i.condition = item.result.condition;
        i.value = item.result.value;
        arr.push(i);
      });
      params["行研究指标"] = arr;
    }
    PostDataExport(this, params).then((data: any) => {
      window.open(
        window.API_ROOT + "api/wajue/download?filename=" + data.file_name
      );
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (!this.$route.query.project_id || !this.$route.query.group_id) {
      this.$message.error("参数有误，请稍等后重新操作");
      this.$router.back();
      return;
    }
    this.project.project_id = this.$route.query.project_id;
    this.group.group_id = this.$route.query.group_id;
    this.fetchHospitals();
    this.fetchTemplates();
    this.fetchRightTemplates();
  }
}
